import { boolean, object, string } from "yup";
import type { Address } from "./Address";
import { DateTime } from "luxon";

export interface User {
  name: string;
  surname: string;
  email: string;
  gender: string;
  phones?: string[];
  birthDate?: string;
  facebookId?: string;
  places?: Array<Address>;
  fidelityCard?: {
    points?: number;
    prepaidAmount?: number;
    prepaidAmountTicket?: number;
    qrcode: string;
    code: string;
    affiliation: string;
  };
}

export interface UserProfile {
  name: string;
  surname: string;
  gender: string;
  phone: string;
  birthDate: string;
}

export enum ProfileFields {
  NAME = "name",
  SURNAME = "surname",
  GENDER = "gender",
  PHONE = "phone",
  BIRTH_DATE = "birthDate"
}

export const useProfileValidator = ({ gender, birthDate }: { gender: boolean, birthDate: boolean }) => {
  const schema = object({
    name: string().required().label('form.name.fieldName'),
    surname: string().required().label('form.surname.fieldName'),
    gender: (gender ? string().required() : string()).label('form.gender.placeholder'),
    phone: string().required().test('phone', '', function(value, ctx) {
      if(!value) return ctx.createError({ message: ({ label }) => ({ key: 'form.errors.invalid', params: { label }}) });
      else if(/^\+?[1-9]\d{1,14}$/.test(value)) return true;
      else return ctx.createError({ message: ({ label }) => ({ key: 'form.errors.invalid', params: { label }}) });
    }).label('form.phone.fieldName'),
    birthDate: string().test('birthdate', '', function(value, ctx) {
      if(!value) {
        if(!birthDate) return true;
        else return ctx.createError({ message: ({ label }) => ({ key: 'form.errors.invalid', params: { label }}) });
      } else if(/\d{4}-\d{2}-\d{2}/.test(value) && DateTime.fromFormat(value, "yyyy-MM-dd") < DateTime.now()) return true;
      else return ctx.createError({ message: ({ label }) => ({ key: 'form.errors.invalid', params: { label }}) });
    }).label('form.birthDate.placeholder')
  });
  return {
    isValid: schema.isValidSync.bind(schema),
    schema
  }
}

export interface FidelityCardMovement {
  id: string;
  locationName: string;
  reason: string;
  type: "fidelity_card_movement";
  pointsVariation: number;
  amountVariation: number;
  ticketAmountVariation: number;
  fidelityCardId: string;
  log: {
    createdDate: string;
  };
  processedDate: string;
  purpose: string;
}
